import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1625.504 -4146.566)">
      <path
        d="M18.246,43.316a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1628 4104)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M27.883,46.829a14.936,14.936,0,0,0-9.638-3.513v15Z"
        transform="translate(-1628 4104)"
        fill={color}
      />
    </g>
  </svg>
);
